import React from 'react';
import { SpinLoader } from 'react-css-loaders';

// NOTE: react-css-loaders is too heavy. Find a replacement.
// take a look to: https://loading.io/spinner/basketball/-basketball-rotating-spinner

/**
 * - background: PropTypes.string  #fff
 * - color: PropTypes.string #000
 * - duration: PropTypes.number 1.4
 * - size: PropTypes.number 10

 * @param {*} props
 */
const Spinner = props => (
  <div className="Spinner ">
    <SpinLoader color="#e8edf1" {...props} />
  </div>
);

export default Spinner;

/*
const Basketball = () => (
  <svg
    width="100%"
    height="100%"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    class="lds-basketball"
  >
    <circle
      cx="50"
      cy="50"
      ng-attr-r="{{config.radius}}"
      fill="#e8edf1"
      stroke="#929292"
      stroke-width="2"
      r="40"
    ></circle>
    <path
      ng-attr-d="{{config.dLine}}"
      ng-attr-stroke="{{config.c2}}"
      ng-attr-stroke-width="{{config.width}}"
      d="M50 10L50 90"
      stroke="#929292"
      stroke-width="2"
    ></path>
    <path
      ng-attr-d="{{config.dCurve1}}"
      fill="none"
      ng-attr-stroke="{{config.c2}}"
      ng-attr-stroke-width="{{config.width}}"
      d="M21.715728752538098 21.7157287525381 A40 40 0 0 1 21.715728752538098 78.2842712474619"
      stroke="#929292"
      stroke-width="2"
    ></path>
    <path
      ng-attr-d="{{config.dCurve2}}"
      fill="none"
      ng-attr-stroke="{{config.c2}}"
      ng-attr-stroke-width="{{config.width}}"
      d="M78.2842712474619 21.7157287525381 A40 40 0 0 0 78.2842712474619 78.2842712474619"
      stroke="#929292"
      stroke-width="2"
    ></path>
    <g transform="translate(0 50)">
      <g>
        <path
          ng-attr-d="{{config.dRoundStatic}}"
          fill="none"
          ng-attr-stroke="{{config.c2}}"
          ng-attr-stroke-width="{{config.width}}"
          d="M 10 0 A 40 12.3027 0 0 1 90 0"
          stroke="#929292"
          stroke-width="2"
        >
          <animate
            attributeName="d"
            calcMode="spline"
            values="M10 0A40 40 0 0 1 90 0;M10 0A40 0 0 0 1 90 0;M10 0A40 0 0 0 0 90 0;M10 0A40 40 0 0 0 90 0"
            keyTimes="0;0.499999;0.5;1"
            dur="1"
            keySplines="0.1 0 1 0.9;0.5 0.5 0.5 0.5;0 0.1 0.9 1"
            begin="0s"
            repeatCount="indefinite"
          ></animate>
        </path>
        <path
          ng-attr-d="{{config.dRoundStatic}}"
          fill="none"
          ng-attr-stroke="{{config.c2}}"
          ng-attr-stroke-width="{{config.width}}"
          d="M 10 0 A 40 32.7407 0 0 0 90 0"
          stroke="#929292"
          stroke-width="2"
        >
          <animate
            attributeName="d"
            calcMode="spline"
            values="M10 0A40 40 0 0 1 90 0;M10 0A40 0 0 0 1 90 0;M10 0A40 0 0 0 0 90 0;M10 0A40 40 0 0 0 90 0"
            keyTimes="0;0.499999;0.5;1"
            dur="1"
            keySplines="0.1 0 1 0.9;0.5 0.5 0.5 0.5;0 0.1 0.9 1"
            begin="-0.5s"
            repeatCount="indefinite"
          ></animate>
        </path>
      </g>
    </g>
  </svg>
);
*/
